var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGitHubOriginal = function SvgGitHubOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 .252c-5.531 0-10 4.469-10 10 0 4.406 2.876 8.157 6.843 9.5.5.094.688-.219.688-.469v-1.687c-2.781.593-3.375-1.344-3.375-1.344-.469-1.157-1.125-1.469-1.125-1.469-.905-.625.063-.594.063-.594 1 .063 1.53 1.031 1.53 1.031.907 1.532 2.345 1.095 2.907.843.095-.655.343-1.092.625-1.342-2.219-.25-4.562-1.125-4.562-4.938 0-1.094.375-1.968 1.03-2.687-.093-.25-.437-1.281.095-2.657 0 0 .842-.281 2.75 1.032a9.7 9.7 0 0 1 2.5-.343 9.5 9.5 0 0 1 2.5.343c1.907-1.282 2.75-1.032 2.75-1.032.531 1.376.187 2.407.094 2.657.657.686 1.031 1.593 1.031 2.686 0 3.844-2.344 4.688-4.563 4.938.343.313.688.906.688 1.843v2.752c0 .281.187.593.687.468C17.126 18.408 20 14.658 20 10.252a9.99 9.99 0 0 0-10-10"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitHubOriginal);
export { ForwardRef as ReactComponent };